import React, { ReactElement } from 'react';
import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { Caption } from 'views/mutual/caption';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { TemplateProps } from '../common';
import PDFViewer from 'views/mutual/pdfViewer';


export const OfferConfirm = ({
  isUpdate,
}: TemplateProps) => {
  useCustomLocationName('口座開設');
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();
  return (
    <>
    {!isUpdate && <Caption label="一般投資家への移行" />}
      {!isUpdate && (
        <div className='ccountOpenTemplate_offer-confirm'>
          <iframe src={`${process.env.PUBLIC_URL}/pdf/offerData.pdf`} 
            style={{
              width: '100%',
              height:'600px',
              border:'0'
            }}/>
          <div className="accountOpenTemplate_button"> 
            <Button
              label={isUpdate ? '登録情報の変更' : '一般投資家として取り扱うよう申し出ます'}
              buttonFill={ButtonFill.black}
              buttonSize={ButtonSize.medium}
              onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.consentConfirm)}
            />
            <Button
              label="前の画面に戻る"
              buttonFill={ButtonFill.link}
              buttonSize={ButtonSize.small}
              onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.selectGeneralInvestor)}
            />
          </div>        
        </div>
      )}
    </>
  );
};
